import { useState, useCallback } from "react";
import { IPrefOption } from "components/popups/NicheForm/NicheForm";
import { PREFERENCES_CHECKBOXES } from "../constants";

export const useNicheFormState = (
  initialPrefOptions: IPrefOption[] = PREFERENCES_CHECKBOXES,
  initialTags: string[] = []
) => {
  const [avatarTicketId, setAvatarTicketId] = useState<string>("");
  const [bannerTicketId, setBannerTicketId] = useState<string>("");
  const [prefOptions, setPrefOptions] = useState<IPrefOption[]>(initialPrefOptions);
  const [tags, setTags] = useState<string[]>(initialTags);

  const handleAvatarTicketId = useCallback((ticketId: string) => {
    setAvatarTicketId(ticketId);
  }, []);

  const handleBannerTicketId = useCallback((ticketId: string) => {
    setBannerTicketId(ticketId);
  }, []);

  const onTagsChange = useCallback((newTags: string[]) => {
    setTags(newTags);
  }, []);

  const onSetPreferences = (prefs: IPrefOption[]) => {
    setPrefOptions(prefs);
  };

  return {
    avatarTicketId,
    bannerTicketId,
    prefOptions,
    tags,
    onTagsChange,
    onSetPreferences,
    handleAvatarTicketId,
    handleBannerTicketId,
  };
};
